module.exports = __webpack_public_path__ + "img/purse.f6f81a79.png";